module.exports = window.mobx;